/* eslint-disable custom-eslint-rules/force-logicalOperandsMustBeBoolean */
import { forwardRef, useMemo } from "react";
import { ToastProvider as NotificationToastProvider } from "react-toast-notifications";
import { useTranslationsContext } from "../TranslationsProvider/TranslationsProvider.context.js";
import { ToastContext } from "./ToastProvider.context.js";
import { StyledToastArea } from "./ToastProvider.style.js";
import { ToastProviderProps } from "./ToastProvider.types.js";
import { buildCustomToast } from "./components/CustomToast/index.js";

export const ToastProvider = forwardRef<HTMLDivElement, ToastProviderProps>(({ children, allowCloseAll = true, ...attributes }, ref): JSX.Element => {
    const { translations } = useTranslationsContext();

    const CustomToast = useMemo(
        () =>
            buildCustomToast({
                closeAllText: translations.toast?.closeAllText || "Close all",
                allowCloseAll,
            }),
        [allowCloseAll],
    );

    const value = useMemo(() => ({ allowCloseAll }), [allowCloseAll]);

    return (
        <ToastContext.Provider value={value}>
            <NotificationToastProvider
                // eslint-disable-next-line
                // @ts-ignore
                components={{ Toast: CustomToast, ToastContainer: StyledToastArea }}
                placement="bottom-left"
                {...attributes}
                ref={ref}
            >
                {children}
            </NotificationToastProvider>
        </ToastContext.Provider>
    );
});
